export  enum LAUNCH_CALLER {
  PRODUCT_360View_IMAGE_ZOOM = "PRODUCT_360View_IMAGE_ZOOM"
}